<template>
  <div v-if="setMagazine">
        <b-row class="mx-2 mb-4 border border-dark">
          <b-col lg="10" class="bg-light border-right border-dark">
            <div class="form-header align-items-center d-flex px-5 py-4">
            <label class="mr-5 mb-0">宛先</label>
            <span class="w-50 mr-2">
              <b-form-select v-model="setMagazine.language" @change="languageDestination" :options="destination" class="form-select ml-1 border-right-0 rounded-0"></b-form-select>
            </span>
            <b-button v-b-modal.modal-center class="px-5 pull-right" variant="primary" :disabled="isDisabled()">リストを表示</b-button>
          </div>
            <b-form-group v-if="setMagazine.language !== 'unselected'" class="form-radio-button">
              <div class="col-10 ml-auto pl-0">
                <input v-model="setMagazine.selected_ng" type="radio" id="ok" value="ok"  @change="userDestination()">
                <label class="mr-4 ml-2" for="ok">OKユーザーのみ</label>
                <input v-model="setMagazine.selected_ng" type="radio" id="all" value="all"  @change="userDestination()">
                <label class="mr-4 ml-2" for="all">NGユーザーを含む</label>
                <input v-model="setMagazine.selected_ng" type="radio" id="ng" value="ng"  @change="userDestination()">
                <label class="mr-4 ml-2" for="ng">NGユーザーのみ</label>
              </div>
            </b-form-group>
          </b-col>
          <b-col lg="2" class="p-0">
            <div class="bg-white h-100 text-center align-items-center d-flex justify-content-center" v-if="destinationIDs">
              <label class="m-0 font-weight-bold">{{ selectedCount }}人</label>
            </div>
          </b-col>
        </b-row>
        <b-modal id="modal-center" ref="modal-center" size="xl" centered :hide-footer="true" :hide-header="true" title="BootstrapVue" v-if="memberFilters">
          <b-container fluid>
              <div class="select-content mb-4">
                <div class="container">
                  <b-row>
                    <b-col lg="2">
                      <b-form-select v-model="memberFilters.country" @change="changeCountry">
                        <b-form-select-option :value="null">国名</b-form-select-option>
                        <b-form-select-option v-for="(country, index) in countries" :key="index" :value="country">{{country}}</b-form-select-option>
                      </b-form-select>
                    </b-col>
                    <b-col lg="2">
                      <b-form-select v-model="memberFilters.prefecture" :disabled="memberFilters.country !== 'Japan'">
                        <b-form-select-option :value="null">都道府県</b-form-select-option>
                        <b-form-select-option v-for="(prefecture, index) in prefectures" :key="index" :value="prefecture">{{prefecture}}</b-form-select-option>
                      </b-form-select>
                    </b-col>
                    <b-col lg="8">
                      <b-row>
                        <div class="col-lg-3 d-flex align-items-center">
                            <b-form-select v-model="memberFilters.age" class="form-select">
                              <b-form-select-option :value="null" disabled="disabled" selected>年齢</b-form-select-option>
                              <b-form-select-option v-for="(item, index) in ageSetup" :key="index" :value="item">{{item + $t('exts')}}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="col-lg-3">
                          <b-form-select v-model="memberFilters.gender">
                            <b-form-select-option :value="null">性別</b-form-select-option>
                            <b-form-select-option value="Male">男性</b-form-select-option>
                            <b-form-select-option value="Female">女性</b-form-select-option>
                          </b-form-select>
                        </div>
                        <div class="col-lg-3">
                          <b-form-select v-model="memberFilters.languages">
                            <b-form-select-option v-for="(language) in [null].concat(languages)" :key="language" :value="language">{{language ? $t(language) : '言語'}}</b-form-select-option>
                          </b-form-select>
                        </div>
                        <div class="col-lg-3">
                          <b-form-select v-model="memberFilters.email">
                            <b-form-select-option :value="null">メルマガ</b-form-select-option>
                            <b-form-select-option value="ok">OK</b-form-select-option>
                            <b-form-select-option value="ng">NG</b-form-select-option>
                          </b-form-select>
                        </div>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col lg="2">
                      <b-form-select v-model="memberFilters.property_use" :options="property_use"></b-form-select>
                    </b-col>
                    <b-col lg="2">
                      <b-form-select v-model="memberFilters.property_types" :options="property_types"></b-form-select>
                    </b-col>
                    <b-col lg="3">
                      <b-form-select v-model="memberFilters.price_range" :options="price"></b-form-select>
                    </b-col>
                    <b-col lg="2">
                      <b-button class="w-100" variant="success" @click="filterReset">リセット</b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            <div class="responsive-table">
                <b-table sticky-header="600px" id="my-table" head-variant="light" bordered
                  :items="filteredPeople"
                  :fields="fields"
                  hover
                >
                  <template #cell(selected)="row">
                      <b-form-checkbox size="lg" v-model="selected" :value="row.item"/>
                  </template>
                  <template #head(selected)="">
                      <b-form-checkbox size="lg" v-model="selectAll" @change="select"><span></span></b-form-checkbox>
                  </template>
                  <template #cell(memberinfo.fullname)="row">
                      <router-link class="text-dark" :to="'/administrator/edit-member/' + row.item.id"> {{ row.value }}</router-link>
                  </template>
                </b-table>
            </div>
            <div class="d-flex justify-content-start align-items-center mt-4">
              <b-button class="py-3 px-5 mr-3" variant="primary" @click="hideModal">キャンセル</b-button>
              <b-button class="py-3 px-5" variant="success" @click="insertList(); hideModal()">決定</b-button>
            </div>
          </b-container>
        </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { languages, memberAges, businessPropertyValues, propertyUses, propertyPrices } from '../../../assets/data/values'

export default {
  data () {
    return {
      property_use: [{ text: '物件用途' }].concat(propertyUses.map(u => { return { value: u, text: this.$i18n.t(u) } })),
      property_types: [{ text: '検討物件' }].concat(Object.values(businessPropertyValues.propertyTypes).flat().map(t => this.$i18n.t(t))),
      price: [{ text: '希望価格帯' }].concat(propertyPrices.map(p => { return { value: p, text: this.$i18n.t(p) } })),
      ageSetup: memberAges,
      destinations: null,
      users: null,
      userLanguage: [
        { text: 'NGユーザーを含む', value: 'all' },
        { text: 'NGユーザーのみ', value: 'ng' }
      ],
      destination: [
        { value: null, text: '選択して下さい', disabled: true }
      ].concat(['unselected'].concat(languages).map((value) => {
        return { value: value, text: this.$i18n.t(`email-target:${value}`) }
      })),
      languages: languages,
      fields: [
        { key: 'selected', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.fullname', label: '氏名', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.country', label: '国名', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.prefectures', label: '都道府県', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.address', label: '住所', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.age', label: '年齢', thStyle: { background: '#F8F9FA' } },
        {
          key: 'memberinfo.gender',
          label: '性別',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value.toLowerCase())
          }
        },
        {
          key: 'memberinfo.use_of_the_property',
          label: '物件用途',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.types_of_properties',
          label: '検討物件',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.desired_price_range',
          label: '希望価格帯',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.language',
          label: '言語',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.email_magazine_delivery',
          label: 'メルマガ',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            if (value) {
              return value.toUpperCase()
            }
          }
        },
        {
          key: 'created_at',
          label: '会員登録日',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return value.substring(0, 10)
          }
        }
      ],
      memberFilters: {
        age: null,
        gender: null,
        email: null,
        country: null,
        prefecture: null,
        languages: null,
        property_types: null,
        price_range: null,
        purchase: null,
        property_use: null
      },
      selectAll: false,
      selected: [],
      selectedPeople: null
    }
  },
  created () {
    this.checkBoxExist()
    this.prefectureCountry()
  },
  computed: {
    ...mapState('latestMember', ['allMember']),
    ...mapState('adminMagazine', ['setMagazine', 'destinationIDs']),
    ...mapState('adminAddMember', ['countries', 'prefectures']),
    filteredPeople: function () {
      return this.allMember.data
        .filter(this.filterByGender)
        .filter(this.filterByEmail)
        .filter(this.filterByAge)
        .filter(this.filterByLanguages)
        .filter(this.filterByCountry)
        .filter(this.filterByPrefecture)
        .filter(this.filterByPropertyUse)
        .filter(this.filterByPropertyType)
        .filter(this.filterByPrice)
    },
    destinationCount: function () {
      return this.allMember.data
        .filter(this.filterDestination)
        .filter(this.filterByEmailSubscription)
    },
    selectedCount: function () {
      if (this.destinationCount.length !== 0) {
        return this.destinationCount.length
      } else if (this.selected.length !== 0 && this.setMagazine.language === 'unselected') {
        return this.selected.length
      } else {
        return '0'
      }
    }
  },
  methods: {
    ...mapActions('latestMember', ['getAllMember']),
    ...mapActions('adminAddMember', ['prefectureCountry']),
    ...mapActions('adminMagazine', ['updateMember', 'getMagazine']),
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (const row in this.allMember.data) {
          this.selected.push(this.allMember.data[row])
        }
      }
      this.selected = this.selected.filter(v => v)
    },
    checkBoxExist: function () {
      if (this.destinationIDs) {
        this.destinationIDs.forEach(element => {
          const id = element - 1
          this.selected.push(this.allMember.data[id])
        })
        if (this.allMember.data.length === this.destinationIDs.length) {
          this.selectAll = true
        }
      }
      this.selected = this.selected.filter(v => v)
    },
    isDisabled () {
      if (this.setMagazine.language !== 'unselected') {
        return true
      }
    },
    filterByAge: function (member) {
      if (this.memberFilters.age === null || this.memberFilters.age === '') {
        return true
      }
      return (member.memberinfo.age === Number(this.memberFilters.age))
    },
    filterByGender: function (member) {
      if (this.memberFilters.gender === null) {
        return true
      }
      return (member.memberinfo.gender === this.memberFilters.gender)
    },
    filterByEmail: function (member) {
      if (this.memberFilters.email === null) {
        return true
      }
      return (member.memberinfo.email_magazine_delivery === this.memberFilters.email)
    },
    filterByLanguages: function (member) {
      if (this.memberFilters.languages === null) {
        return true
      }
      return (member.memberinfo.language === this.memberFilters.languages)
    },
    filterByPropertyUse: function (member) {
      if (this.memberFilters.property_use === null) {
        return true
      }
      return (member.memberinfo.use_of_the_property === this.memberFilters.property_use)
    },
    filterByPrefecture: function (member) {
      if (this.memberFilters.prefecture === null) {
        return true
      }
      return (member.memberinfo.prefectures === this.memberFilters.prefecture)
    },
    filterByCountry: function (member) {
      if (this.memberFilters.country === null) {
        return true
      }
      return (member.memberinfo.country === this.memberFilters.country)
    },
    filterByPrice: function (member) {
      if (this.memberFilters.price_range === null) {
        return true
      }
      return (member.memberinfo.desired_price_range === this.memberFilters.price_range)
    },
    filterByPropertyType: function (member) {
      if (this.memberFilters.property_types === null) {
        return true
      }
      return (member.memberinfo.types_of_properties === this.memberFilters.property_types)
    },
    filterDestination: function (member) {
      if (member.memberinfo !== null && this.languages.includes(this.setMagazine.language)) {
        return (member.memberinfo.language === this.setMagazine.language)
      }
      return (member.memberinfo.language === 'unselected')
    },
    filterByEmailSubscription: function (member) {
      if (this.setMagazine.selected_ng === null) {
        return true
      }
      switch (this.setMagazine.selected_ng) {
        case 'all':
          return true
        case 'ng':
          return (member.memberinfo.email_magazine_delivery === 'ng')
        case 'ok':
          return (member.memberinfo.email_magazine_delivery === 'ok')
      }
    },
    insertList (event) {
      this.$emit('insert', this.selected)
    },
    languageDestination (event) {
      this.$emit('langDestination', this.setMagazine.language)
    },
    userDestination (event) {
      this.$emit('destinationEmail', this.setMagazine.selected_ng)
    },
    hideModal () {
      this.$refs['modal-center'].hide()
    },
    filterReset () {
      this.memberFilters = {
        age: null,
        gender: null,
        email: null,
        country: null,
        prefecture: null,
        languages: null,
        property_types: null,
        price_range: null,
        purchase: null,
        property_use: null
      }
    },
    changeCountry () {
      if (this.memberFilters.country !== 'Japan') {
        this.memberFilters.prefecture = null
      }
    }
  },
  components: {

  }
}
</script>
